import ReactPortal from './ReactPortal';

export default ReactPortal;
